/**
 * product-reviews.js
 *
 * Handles:
 *  - checking write-review eligibility on load (calls the App Proxy)
 *  - showing/hiding the write-a-review form
 *  - photo preview thumbnails before submit
 *  - submitting the review (multipart/form-data, via the App Proxy)
 *
 * All requests go through /apps/reviews/* — Shopify's App Proxy forwards
 * these to your backend server with a verified signature attached.
 */
(function () {
  const root = document.getElementById('pr-reviews');
  if (!root) return;

  const proxyPath = (window.prReviewsConfig && window.prReviewsConfig.proxyPath) || '/apps/reviews';
  const productId = root.dataset.productId;
  const customerId = root.dataset.customerId || null;
  const isLoggedIn = root.dataset.loggedIn === 'true';
  const loginUrl = root.dataset.loginUrl || '/account/login';

  const writeSection = document.getElementById('pr-write');
  const toggleBtn = document.getElementById('pr-write-toggle');
  const form = document.getElementById('pr-form');
  const gateMessage = document.getElementById('pr-gate-message');
  const photosInput = document.getElementById('pr-photos');
  const photoPreview = document.getElementById('pr-photo-preview');
  const formMessage = document.getElementById('pr-form-message');

  function showGateMessage(text) {
    gateMessage.textContent = text;
    gateMessage.hidden = false;
  }

  function showLoginGate() {
    gateMessage.innerHTML = '';

    const btn = document.createElement('a');
    btn.href = loginUrl;
    btn.className = 'pr-gate-btn';
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>' +
      '<polyline points="10 17 15 12 10 7"/>' +
      '<line x1="15" y1="12" x2="3" y2="12"/>' +
      '</svg>' +
      '<span>Log in to write a review</span>';

    const caption = document.createElement('p');
    caption.className = 'pr-gate-caption';
    caption.textContent = "You'll need to have purchased this product.";

    gateMessage.appendChild(btn);
    gateMessage.appendChild(caption);
    gateMessage.hidden = false;
  }

  async function checkEligibility() {
    if (!isLoggedIn) {
      showLoginGate();
      return;
    }

    try {
      const url = `${proxyPath}/eligibility?product_id=${encodeURIComponent(productId)}&customer_id=${encodeURIComponent(customerId)}`;
      const res = await fetch(url, { credentials: 'omit' });
      const data = await res.json();

      if (data.eligible) {
        writeSection.hidden = false;
      } else {
        showGateMessage('Reviews are limited to customers who have purchased this product.');
      }
    } catch (err) {
      console.error('Reviews eligibility check failed:', err);
      // Fail closed: don't show the form if we can't confirm eligibility.
      showGateMessage('Unable to check review eligibility right now. Please try again later.');
    }
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      const isHidden = form.hidden;
      form.hidden = !isHidden;
      toggleBtn.textContent = isHidden ? 'Cancel' : 'Write a review';
    });
  }

  if (photosInput) {
    photosInput.addEventListener('change', () => {
      photoPreview.innerHTML = '';
      const files = Array.from(photosInput.files || []).slice(0, 5);
      files.forEach((file) => {
        const img = document.createElement('img');
        img.className = 'pr-form__photo-thumb';
        img.width = 60;
        img.height = 60;
        img.alt = file.name;

        img.onerror = () => {
          // Browser couldn't render this format (some HEIC files, etc.) —
          // show a filename chip instead of a broken image icon. The file
          // itself is still selected and will still upload fine.
          const fallback = document.createElement('div');
          fallback.className = 'pr-form__photo-thumb pr-form__photo-thumb--fallback';
          fallback.textContent = file.name.length > 10 ? file.name.slice(0, 8) + '…' : file.name;
          img.replaceWith(fallback);
        };

        const reader = new FileReader();
        reader.onload = (e) => { img.src = e.target.result; };
        reader.readAsDataURL(file);
        photoPreview.appendChild(img);
      });
    });
  }

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      formMessage.textContent = '';

      const submitBtn = form.querySelector('.pr-form__submit');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting\u2026';

      try {
        const fd = new FormData();
        fd.append('product_id', productId);
        fd.append('customer_id', customerId);
        fd.append('rating', document.getElementById('pr-rating').value);
        fd.append('title', '');
        fd.append('body', document.getElementById('pr-body').value);

        const files = Array.from(photosInput.files || []).slice(0, 5);
        files.forEach((file) => fd.append('photos', file));

        const res = await fetch(`${proxyPath}`, {
          method: 'POST',
          body: fd,
          credentials: 'omit',
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.error || `Request failed (${res.status})`);
        }

        form.reset();
        photoPreview.innerHTML = '';
        form.hidden = true;
        toggleBtn.textContent = 'Write a review';
        formMessage.textContent = 'Thanks! Your review has been submitted and is pending approval.';
        formMessage.hidden = false;
      } catch (err) {
        console.error('Review submission failed:', err);
        formMessage.textContent = 'Something went wrong submitting your review. Please try again.';
        formMessage.hidden = false;
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit review';
      }
    });
  }

  const filterBtn = document.getElementById('pr-filter-photos');
  if (filterBtn) {
    const allReviews = Array.from(root.querySelectorAll('.pr-review'));
    filterBtn.addEventListener('click', () => {
      const isActive = filterBtn.getAttribute('aria-pressed') === 'true';
      const next = !isActive;
      filterBtn.setAttribute('aria-pressed', String(next));
      allReviews.forEach((el) => {
        if (next) {
          el.hidden = el.dataset.hasPhotos !== 'true';
        } else {
          el.hidden = false;
        }
      });
    });
  }

  checkEligibility();
})();